import type { PaymentProviderBase } from "../payment-provider-base";

const FreePaymentTypes = ["free"] as const;
type FreePaymentType = typeof FreePaymentTypes[number];
const freePaymentProvider: PaymentProviderBase<"FREE", FreePaymentType> = {
    _type: "FREE-PAYMENT_PROVIDER",
    name: "FREE",
    displayName: "På plats",
    paymentTypes: FreePaymentTypes,
};

type FreePaymentProvider = typeof freePaymentProvider;

export type { FreePaymentType, FreePaymentProvider };
export { FreePaymentTypes, freePaymentProvider };
